import axios from "axios";
import { URLDevelopment } from "../../helpers/URL";

export const getProductDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: "PRODUCT_DETAILS_REQUEST" });

    const { data } = await axios.get(
      `${URLDevelopment}/api/product/${id}`
    );
////const res = await axios.get(`${URLDevelopment}/api/user`);
    dispatch({
      type: "PRODUCT_DETAILS_SUCCESS",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "PRODUCT_DETAILS_FAIL",
      payload:
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message,
    });
  }
};

// FEATURED
export const getFeaturedProducts = () => async (dispatch) => {
  try {
    dispatch({ type: "PRODUCT_LOADING" });

    const { data } = await axios.get(
       `${URLDevelopment}/api/product/featured`
    );

    dispatch({
      type: "FEATURED_PRODUCTS_SUCCESS",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "PRODUCT_ERROR",
      payload: error.message,
    });
  }
};

// SALE
export const getSaleProducts = () => async (dispatch) => {
  try {
    dispatch({ type: "PRODUCT_LOADING" });

    const { data } = await axios.get(
       `${URLDevelopment}/api/product/sale`
    );

    dispatch({
      type: "SALE_PRODUCTS_SUCCESS",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "PRODUCT_ERROR",
      payload: error.message,
    });
  }
};